"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _DividerSt = require("./Divider.st.css");
var _constants = require("./constants");
var _jsxFileName = "/home/builduser/work/b60d7defec63c7cc/packages/wix-style-react/dist/cjs/Divider/Divider.js";
/** A component that separates content by a line horizontally or vertically */
class Divider extends _react.default.PureComponent {
  render() {
    var {
      dataHook,
      className,
      direction,
      skin
    } = this.props;
    return /*#__PURE__*/_react.default.createElement("hr", {
      "data-hook": dataHook,
      className: (0, _DividerSt.st)(_DividerSt.classes.root, {
        direction,
        skin
      }, className),
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 37,
        columnNumber: 7
      }
    });
  }
}
Divider.displayName = 'Divider';
Divider.propTypes = {
  /** Applies a data-hook HTML attribute that can be used in the tests. */
  dataHook: _propTypes.default.string,
  /** Controls divider direction. */
  direction: _propTypes.default.oneOf(['horizontal', 'vertical']),
  /** Sets the skin of the divider. */
  skin: _propTypes.default.oneOf(['light', 'dark', 'standard', 'warning', 'destructive', 'success', 'premium'])
};
Divider.defaultProps = {
  direction: _constants.directions.horizontal,
  skin: _constants.skins.light
};
var _default = exports.default = Divider;
//# sourceMappingURL=Divider.js.map